var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":"","align":"center"}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('div',{staticClass:"container-width px-2"},[_c('POISnapshot')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }